import { memo, type ReactNode } from 'react';

export type MainSideNavOverlayTrayHeaderProps = {
  description: string | undefined;
  rightSuffix?: ReactNode;
  title: ReactNode;
};

export const MainSideNavOverlayTrayHeader = memo(
  ({ description, rightSuffix, title }: MainSideNavOverlayTrayHeaderProps) => {
    return (
      <div
        className="sticky top-0 z-10 shrink-0 ads:border-default border-gray-4 border-b ads:bg-base bg-gray-1 pt-4"
        data-testid="MAIN_SIDE_NAV_OVERLAY_TRAY_HEADER"
      >
        <div className="flex items-center justify-between px-4 pb-3">
          <h2 className="min-w-0 flex-1 truncate pr-3 font-semibold ads:text-primary text-14 text-gray-12">
            <span data-testid="MAIN_SIDE_NAV_OVERLAY_TRAY_HEADER_TITLE">{title}</span>
            {description ? (
              <span
                className="font-normal ads:text-metadata text-gray-9"
                data-testid="MAIN_SIDE_NAV_OVERLAY_TRAY_HEADER_DESCRIPTION"
              >
                {` · ${description}`}
              </span>
            ) : null}
          </h2>
          {rightSuffix}
        </div>
      </div>
    );
  },
);

MainSideNavOverlayTrayHeader.displayName = 'MainSideNavOverlayTrayHeader';
